module.exports = __webpack_public_path__ + "media/images/gallery/gal_on-c7362e021a048f3f7162b22406017dbf.gif";